import React__default from 'react';
import Badge from '../Badge.js';
import { BulkLoadListStatusText, BulkLoadListStatus } from '../../../constants/bulkLoadListCardStatusMap.js';
import { BadgeTypes } from '../../../constants/misc.js';

const BulkLoadListBadgeController = ({ status, badgeClass, onClick }) => {
    const statusText = BulkLoadListStatusText[BulkLoadListStatus[status]];
    const renderBadge = () => {
        switch (status) {
            case BulkLoadListStatus.PUBLISHED:
            case BulkLoadListStatus.PARTIAL_PUBLISHED:
                return (React__default.createElement(Badge, { type: BadgeTypes.PUBLISHED, text: statusText, badgeClass: badgeClass, squaredEdges: true, onClick: onClick }));
            case BulkLoadListStatus.UNDER_REVIEW:
                return React__default.createElement(Badge, { type: BadgeTypes.PROGRESS, text: statusText, badgeClass: badgeClass, squaredEdges: true });
            default:
                return React__default.createElement(Badge, { type: BadgeTypes.DEFAULT, text: statusText, badgeClass: badgeClass, squaredEdges: true });
        }
    };
    return renderBadge();
};

export { BulkLoadListBadgeController as default };
//# sourceMappingURL=BulkLoadListBadgeController.js.map
